
const tagContext = {
    'Dark': [
        "#5c5c5c",
        "#ea4861",
        "#c40879",
        "#b14aed",
        "#5c95ff",
        "#f57600",
        "#90be6d",
        "#43aa8b",
        "#4d908e",
        "#577590"
    ],

    'Light': [
        "#5c5c5c",
        "#ea4861",
        "#c40879",
        "#b14aed",
        "#5c95ff",
        "#f57600",
        "#90be6d",
        "#43aa8b",
        "#4d908e",
        "#577590"
    ]
}

class Tag {
    constructor(props){
        let updatedProps = props || {}
        this.tagID = updatedProps.tagID || updatedProps['_id'];
        this.color = updatedProps.color || tagContext['Dark'][0];
        this.content = updatedProps.content;
        this.pageID = updatedProps.pageID;
        this.userID = updatedProps.userID;
    }
}

export default Tag;